import Vue from "vue";
import Router from "vue-router";
import store from "@/store/store";
import NoAuth_Home from "@/views/NoAuth_Home";
// import SignIn from '@/views/SignIn'
import SignOut from "@/views/SignOut";
import SignUp from "@/views/SignUp";
import Profile from "@/views/Profile";
import News from "@/views/News";
import CreatePost from "@/views/CreatePost";
import Search from "@/views/Search";
import News1 from "@/views/News_individual";
import ShareNews from "@/views/ShareNews";
import ReviewNews from "@/views/reviewNews";
import Suggestion from "@/views/Suggestion";
import ForgotPassword from "@/views/ForgotPassword";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "prehome",
      component: NoAuth_Home,
      meta: {
        title: "The Concord Report",
        metaTags: [
          {
            name: "description",
            content:
              "The Dynamic Social Ecosystem That Makes News Engagement A Community-Centric Experience",
          },
        ],
      },
    },
    {
      path: "/news",
      name: "news",
      component: News,
      meta: {
        authRequired: true,
        title: "The Concord Report",
        metaTags: [
          {
            name: "description",
            content:
              "The Dynamic Social Ecosystem That Makes News Engagement A Community-Centric Experience",
          },
        ],
      },
    },
    {
      path: "/news/:id",
      name: "news_individual",
      component: News1,
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/share/:id",
      name: "news_share",
      component: ShareNews,
      meta: {
        authRequired: false,
      },
    },
    {
      path: "/reviewnews",
      name: "news_review",
      component: ReviewNews,
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/signout",
      name: "signout",
      component: SignOut,
    },
    {
      path: "/passwordrecovery",
      name: "ForgotPassword",
      component: ForgotPassword,
    },
    {
      path: "/signup",
      name: "signup",
      component: SignUp,
      meta: {
        title: "The Concord Report - Sign In",
        metaTags: [
          {
            name: "description",
            content:
              "Sign In and Explore! The Dynamic Social Ecosystem That Makes News Engagement A Community-Centric Experience",
          },
        ],
      },
    },
    {
      path: "/createpost",
      name: "createpost",
      component: CreatePost,
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/suggestions",
      name: "suggestion",
      component: Suggestion,
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/search/:id",
      name: "search",
      component: Search,
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/search/",
      name: "searchBlank",
      component: Search,
      meta: {
        authRequired: true,
      },
      props: true,
    },
    {
      path: "/profile/:id",
      name: "profile",
      component: Profile,
      meta: {
        authRequired: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.authRequired)) {
    if (!store.state.user) {
      next({
        path: "/",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
